import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import SchoolDrive from './SchoolDrive';

const HomeLazy = React.lazy(
	() => import(/* webpackChunkName : 'Home' */ './components/Home')
);

export default (store) => {
	return [
		{
			path: 'home',
			element: <AsyncLoading component={<HomeLazy />} />,
		},
		...SchoolDrive(store),
	];
};
